import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import Auth from '@Services/Auth';
import GeneralDialogLayout from '@Containers/Dialogs/GeneralDialogLayout';
import RegisterModalForm from './Components/RegisterModalForm';

import './RegisterModal.scss';

function RegisterModal(props) {
  const { isAnonymousUser, cancel, init, resetState } = props;

  const keyUpListener = (e) => {
    if (e && e.keyCode === 27 && isAnonymousUser) {
      cancel();
    }
  };

  useEffect(() => {
    if (isAnonymousUser === false && Auth.isReaxysAllowed()) {
      cancel();
      return;
    }
    init();
    document.addEventListener('keyup', keyUpListener);
    // eslint-disable-next-line consistent-return
    return () => {
      resetState();
      document.removeEventListener('keyup', keyUpListener);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <GeneralDialogLayout size="md" movable={false} className="react-dialogs-scrollable register-modal" closeBtn={false}>
      <RegisterModalForm {...props} />
    </GeneralDialogLayout>
  );
}

RegisterModal.propTypes = {
  isAnonymousUser: PropTypes.bool,
  cancel: PropTypes.func.isRequired,
  init: PropTypes.func.isRequired,
  resetState: PropTypes.func.isRequired,
};

export default RegisterModal;
